<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomLoader from "@/components/widgets/custom-loader";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

export default {
  page: {
    title: "School Pass Mark",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, CustomLoader },
  data() {
    return {
      title: "School Pass Mark",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Pass Mark",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "class",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "classx",
          label: "Level",
          sortable: true,
        },
        {
          key: "marks",
          label: "Mark",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "Action",
        },
      ],
      passMark: {
        year: "",
        class: "",
        mark_type: 0,
        mark: "",
      },
      editPassMark: {
        year: "",
        class: "",
        mark_type: 0,
        mark: "",
        id: "",
      },
      deletePassMark: {
        mark: "",
        id: "",
      },
    };
  },
  computed: {
    ...mapGetters("marks", ["getPassMark", "SaveStatus"]),
    ...mapGetters("classes", ["AllClasses"]),
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    rows() {
      return this.getPassMark.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.getPassMark.length;
  },
  methods: {
    ...mapActions({
      AddPassMark: "marks/addPassMark",
      EditPassMark: "marks/editPassMark",
      DeletePassMark: "marks/deletePassMark",
      FetchPassMarks: "marks/fetchPassMarks",
      FetchYears: "marks/fetchYear",
      FetchClasses: "classes/fetchClasses",
    }),
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.getPassMark.length;
      this.currentPage = 1;
    },
    resetAddModal() {
      // this.data.name = "";
      this.resetError();
    },
    submitPassMark(modal) {
      this.modal = modal;
      this.AddPassMark(this.passMark);
      this.closeModal(modal);
    },
    updatePassMark(modal) {
      this.modal = modal;
      this.editPassMark.year = modal.item.year;
      this.editPassMark.class = modal.item.classx.id;
      this.editPassMark.mark = modal.item.marks;
      this.editPassMark.id = modal.item.id;
    },
    updatePassMarkSubmit(modal) {
      this.EditPassMark(this.editPassMark);
      this.closeModal(modal);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    showDeleteModal(modal) {
      this.deletePassMark.mark = modal.item.marks;
      this.deletePassMark.id = modal.item.id;
    },
    deleteStd(modal) {
      this.modal = modal;
      this.DeletePassMark(this.deletePassMark);
      this.closeModal(modal);
    },
  },
  created() {
    this.FetchPassMarks();
    this.FetchYears();
    this.FetchClasses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_pass_mark')
        )
      "
    >
      <div class="col-md-12 mb-3">
        <a
          v-if="
            getCurrentUser.permissions.find((item) =>
              item.permission.includes('add_pass_mark')
            )
          "
          v-b-modal.add-pass-modal
          name=""
          id=""
          class="btn btn-primary btn-sm float-end"
          href="#"
          role="button"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
          Pass Mark
        </a>
      </div>
      <CustomLoader v-if="SaveStatus"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0" v-if="getPassMark.length > 0">
              <b-table
                class="datatables student-list"
                :items="getPassMark"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group class="mb-2">
                    <b-button
                      size="sm"
                      class="btn btn-primary"
                      v-b-modal.update-pass-modal
                      @click="updatePassMark(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_pass_mark')
                        )
                      "
                    >
                      <i class="fa fa-edit"></i> Edit
                    </b-button>
                    <b-button
                      size="sm"
                      class="btn btn-danger"
                      v-b-modal.delete-pass-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_pass_mark')
                        )
                      "
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i> Delete
                    </b-button>
                  </b-button-group>
                </template>
                <template #cell(classx)="data">
                  {{ data.item.classx.name }}
                </template>
              </b-table>
            </div>
            <div class="row d-flex" v-else>
              <p class="text-secondary my-3">No data found</p>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- add pass mark  -->
      <b-modal
        id="add-pass-modal"
        size="md"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_pass_mark')
          )
        "
      >
        <template #modal-title> Add School Pass Mark </template>
        <form @submit.prevent="submitPassMark('add-pass-modal')">
          <div class="card-body row">
            <div class="form-group col-md-6">
              <div class="form-group mt-2">
                <label for="">Year <small class="text-danger">*</small></label>
                <select
                  class="form-control"
                  required
                  v-model="passMark.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="form-group mt-2">
                <label for="">Level <small class="text-danger">*</small></label>
                <select
                  class="form-control"
                  required
                  v-model="passMark.class"
                  @change="fetchStreamsinClass($event)"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Level</option>
                  <option
                    v-for="(classes, index) in AllClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- <div class="form-group col-md-6">
              <div class="form-group mt-2">
                <label for=""
                  >Pass Mark Type <small class="text-danger">*</small></label
                >
                <select
                  class="form-control"
                  required
                  v-model="passMark.mark_type"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Class</option>
                  <option value="1">Aggregate Mark</option>
                  <option value="0">Average Mark</option>
                </select>
              </div>
            </div> -->
            <div class="form-group col-md-6 mt-2">
              <label>Pass Mark <small class="text-danger">*</small> </label>
              <div class="input-group">
                <input
                  type="number"
                  placeholder="Enter Mark e.g 25"
                  class="form-control"
                  v-model="passMark.mark"
                  required
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger btn-sm"
              data-dismiss="modal"
              @click="closeModal('add-pass-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
              type="submit"
              size="sm"
              disabled
              class="btn btn-sm btn-outline-primary"
              v-if="SaveStatus"
            >
              <b-spinner
                variant="primary"
                small
                label="Fetching Data..."
              ></b-spinner>
              Submiting Mark...
            </button>
            <button
              v-else
              type="submit"
              size="sm"
              class="btn btn-sm btn-outline-primary"
            >
              <i class="fa fa-check"></i>
              Submit Mark
            </button>
          </div>
        </form>
      </b-modal>

      <!-- modal pass mark -->
      <b-modal
        id="update-pass-modal"
        size="md"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_pass_mark')
          )
        "
      >
        <template #modal-title> Update Pass Mark </template>
        <form @submit.prevent="updatePassMarkSubmit('update-pass-modal')">
          <div class="card-body row">
            <div class="form-group col-md-6">
              <div class="form-group">
                <label for="">Year <small class="text-danger">*</small></label>
                <select
                  class="form-control"
                  required
                  v-model="editPassMark.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="form-group">
                <label for="">Level <small class="text-danger">*</small></label>
                <select
                  class="form-control"
                  required
                  v-model="editPassMark.class"
                  @change="fetchStreamsinClass($event)"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Level</option>
                  <option
                    v-for="(classes, index) in AllClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.name }}
                  </option>
                </select>
              </div>
            </div>
            <!-- <div class="form-group col-md-6">
              <div class="form-group mt-2">
                <label for=""
                  >Pass Mark Type <small class="text-danger">*</small></label
                >
                <select
                  class="form-control"
                  required
                  v-model="editPassMark.mark_type"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Class</option>
                  <option value="1">Aggregate Mark</option>
                  <option value="0">Average Mark</option>
                </select>
              </div>
            </div> -->
            <div class="form-group col-md-6 mt-2">
              <label>Pass Mark <small class="text-danger">*</small> </label>
              <div class="input-group">
                <input
                  type="number"
                  placeholder="Enter Mark e.g 25"
                  class="form-control"
                  v-model="editPassMark.mark"
                  required
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger btn-sm"
              data-dismiss="modal"
              @click="closeModal('update-pass-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
              v-if="SaveStatus"
              type="submit"
              disabled
              class="btn btn-primary btn-sm"
            >
              <b-spinner variant="light" small label="Spinning"></b-spinner>
              Submiting...
            </button>
            <button v-else type="submit" class="btn btn-outline-success btn-sm">
              <i class="fa fa-save"></i>
              Update Mark
            </button>
          </div>
        </form>
      </b-modal>

      <!-- modal delete pass mark starts -->
      <b-modal
        id="delete-pass-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_pass_mark')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">
            Delete Pass Mark:
            <strong>{{ deletePassMark.mark }}</strong>
          </h5>
        </template>
        <div class="form-group mb-3">
          <div class="input-group">
            <h6 class="px-4">
              Do you want to delete Pass Mark,
              <strong>{{ deletePassMark.mark }}</strong
              >?
              <br />
              <br />
              <strong>Click Proceed Button to delete.</strong>
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            data-dismiss="modal"
            @click="closeModal('delete-pass-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            disabled
            class="btn btn-outline-danger btn-sm"
          >
            <b-spinner variant="danger" small label=""></b-spinner>
            Wait, Deleting Mark
          </button>
          <button
            v-else
            type="button"
            class="btn btn-outline-danger btn-sm"
            @click="deleteStd()"
          >
            <i class="fa fa-trash"></i> Proceed
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
